import { fetchFiltersMeta } from '../../services/fetchFiltersMeta';
import { IFiltersMeta } from '../../types/filters';
import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EFiltersActionType, TSetMeta, TStartFetchingMeta } from './types';

export const startFetchingMeta: () => TStartFetchingMeta = actionGenerator<EFiltersActionType.StartFetchingMeta>(
  EFiltersActionType.StartFetchingMeta,
);

export const setMeta: (meta: IFiltersMeta) => TSetMeta = actionGenerator<EFiltersActionType.SetMeta, IFiltersMeta>(
  EFiltersActionType.SetMeta,
);

export const updateMeta = (): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    dispatch(startFetchingMeta());

    const {
      filters: { savedFilters },
      buildersProjects: {
        data: { location },
      },
    } = getState();

    const meta = await fetchFiltersMeta(context, { ...savedFilters, regionId: location?.id });

    dispatch(setMeta(meta));
  };
};
